// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"module"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3L3 21H12L12 12L12 3L3 3Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 3L12 3L12 21H21L21 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 3H3V21H12M12 3V12M12 3H21V21M12 3V21M12 21V12M12 21H21M12 12H21V21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ModuleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'module',
    ref,
    icon: element,
  },
));

ModuleIcon.displayName = 'ModuleIcon';

export default ModuleIcon;
